$(document).ready(function(){
    // Create a new div element that will act as the back arrow container
    var $backArrow = $('<div class="we-single-back-btn"></div>');

    // Set the content of the back arrow to your SVG
    $backArrow.html('<svg width="51" height="38" viewBox="0 0 51 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 21.5C49.3807 21.5 50.5 20.3807 50.5 19C50.5 17.6193 49.3807 16.5 48 16.5V21.5ZM1.23223 17.2322C0.255924 18.2085 0.255924 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM48 16.5L3 16.5V21.5L48 21.5V16.5Z" fill="white"/></svg>'); // SVG arrow is now used

    // Apply CSS to position the element absolutely within #we-trip-description
    $backArrow.css({
        'position': 'absolute',
        'top': '0px', // Adjust as needed
        'left': '0px', // Adjust as needed
        'z-index': '1000', // Ensure it sits above other content; adjust as needed
        'background-color': '#42BABE', // Optional: background color
        'padding': '5px', // Optional: padding
        'border-radius': '0px', // Optional: border radius for a rounded look
        'cursor': 'pointer', // Change cursor on hover to indicate it's clickable
        'width': '60px', // Adjust width as needed
        'height': '60px', // Adjust height as needed
        'color': '#fff',
        'font-size': '25px',
    });

    // Optionally, add a click event to the back arrow to perform actions when it's clicked
    $backArrow.on('click', function() {
        window.history.back(); // Go back to the previous page
    });

    // Append the back arrow element to the #we-trip-description container
    $('#we-trip-description').prepend($backArrow);


    


});


